/**
 * Copyright 2022-present terrestris GmbH & Co. KG
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
 * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 */
export default {
  de: {
    translation: {
      Index: {
        applicationLoadErrorMessage: 'Fehler beim Laden der Applikation',
        applicationLoadErrorDescription: 'Die Applikation mit der ID {{applicationId}} konnte nicht geladen werden. ' +
          'Die Standardkonfiguration wird stattdessen geladen.',
        errorMessage: 'Fehler beim Laden der Applikation',
        errorDescription: 'Aufgrund eines unerwarteten Fehlers konnte die Applikation nicht geladen werden. ' +
          'Bitte laden Sie die Seite erneut.'
      },
      Nominatim: {
        placeholder: ' Ortsname, Straßenname, Stadtteilname, POI usw.'
      },
      Drawer: {
        title: 'Themen'
      },
      FeatureInfoDrawer: {
        title: 'FeatureInfo'
      },
      FeatureInfo: {
        usageHint: 'Klicken Sie eine farbige Gebäudefläche an, um Details abzufragen'
      },
      BackgroundLayerChooser: {
        changeBgButtonTooltip: 'Hintergrund wechseln'
      },
      Footer: {
        refSystem: 'Bezugssystem',
        scale: 'Maßstab',
        mousePosition: 'Mausposition'
      },
      LayerTree: {
        transparency: 'Transparenz',
        externalWmsFolder: 'Externe Dienste',
        noLegendAvailable: 'Keine Legende verfügbar'
      },
      LayerTreeContextMenu: {
        layerZoomToExtent: 'Auf Layerausdehnung zoomen',
        extentError: 'Konnte nicht auf die Layerausdehnung zoomen',
        removeLayer: 'Layer entfernen',
        showLegend: 'Legende anzeigen',
        hideLegend: 'Legende ausblenden'
      },
      FeaturePropertyGrid: {
        'lk_oldenburg_pv': 'Photovoltaik',
        'lk_oldenburg_parkplatz_pv': 'Photovoltaik Parkplätze',
        'lk_oldenburg_th': 'Solarthermie',
        'lk_oldenburg_gruen': 'Gründach'
      }
    }
  },
  en: {
    translation: {
      Index: {
        applicationLoadErrorMessage: 'Error while loading the application',
        applicationLoadErrorDescription: 'The application with ID {{applicationId}} could not be loaded correctly. ' +
          'You\'re seeing the default application configuration.',
        errorMessage: 'Error while loading the application',
        errorDescription: 'An unexpected error occured while loading the application. Please try to reload the page.'
      },
      Nominatim: {
        placeholder: ' Place name, street name, district name, POI, etc.'
      },
      Drawer: {
        title: 'Layers'
      },
      FeatureInfoDrawer: {
        title: 'FeatureInfo'
      },
      FeatureInfo: {
        usageHint: 'Click on the map to get informations about the clicked coordinate'
      },
      BackgroundLayerChooser: {
        changeBgButtonTooltip: 'Change background'
      },
      Footer: {
        refSystem: 'Reference system',
        scale: 'Scale',
        mousePosition: 'Mouse position',
        imprint: 'Imprint',
        contact: 'Contact',
        privacypolicy: 'Privacy'
      },
      LayerTree: {
        transparency: 'Transparency',
        externalWmsFolder: 'External services',
        noLegendAvailable: 'No legend available'
      },
      LayerTreeContextMenu: {
        layerZoomToExtent: 'Zoom to layer extent',
        extentError: 'Could not zoom to layer extent',
        removeLayer: 'Remove layer',
        showLegend: 'Show legend',
        hideLegend: 'Hide legend'
      },
      FeaturePropertyGrid: {
        'lk_oldenburg_pv': 'Photovoltaic',
        'lk_oldenburg_parkplatz_pv': 'Photovoltaic parking spaces',
        'lk_oldenburg_th': 'Solar thermal',
        'lk_oldenburg_gruen': 'Green roof'
      }
    }
  }
};
